import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { API_ENDPOINTS, METHOD_TYPE } from "../../../utils/apiUrls";
import api from "../../../utils/api";

const initialState = {
    isLoading: false,
    error: null,
    corporateViewedScreeningList: { rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200 },
    // corporateDetails : {},
    // globalSearches: { rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200 },
    // globalSearchDetail: null,
    // fetchDocuments: { rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200 },
    // adverseMedias:[],
    // amlComments:{ rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200 },
    // screeningComments: { rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200 },
    // fieldHistory: { rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200 },
    // corporateRequestedDocument: { rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200 },
    // oldData: [],
    // pendingCorporateScreeningCount : 0
}

export const fetchCorporateScreeningList = createAsyncThunk("corporate_screening/getCorporateScreeninglist", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCorporateScreeninglist + queryParam
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const corporateResendToScreening = createAsyncThunk("corporate_screening/corporateResendToScreening", async ({ payload, queryParam }) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.corporateResendToScreening + queryParam,
            data: payload
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
})

const fetchCorporateScreeningSlice = createSlice({
    name: "corporateScreening",
    initialState,
    reducers: {
        resetCorporateScreeningList(state, action) {
            state.corporateViewedScreeningList = { rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200 };
        },
        // resetGlobalSearchDetails(state, action) {
        //     state.globalSearchDetail = null;
        // },
        updateCorporateScreeningList(state, action) {
            state.corporateViewedScreeningList = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCorporateScreeningList.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
                state.corporateViewedScreeningList = payload.data;
            })
            // .addCase(fetchCorporateClientPersonalDetail.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            //     state.corporateDetails = payload.data;
            //   })
            // .addCase(manageContinuousMonitoring.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            // })
            // .addCase(manageCorporateClientStatus.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            // })
            // .addCase(downloadCorporateClientDocZipFiles.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            // })
            // .addCase(updateCorporateDetailsWithReason.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            // })
            // .addCase(getAllGlobalSearchById.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            //     state.globalSearches = payload.data;
            // })
            // .addCase(saveRelevantResult.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            // })
            // .addCase(removeRelevantResult.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            // })
            // .addCase(getGlobalSearchById.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            //     state.globalSearchDetail = payload.data;
            // })
            // .addCase(fetchRequestedUploadedDocuments.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            //     state.fetchDocuments = payload.data
            // })
            // .addCase(requestDocument.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            // })
            // .addCase(uploadDocument.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            // })
            // .addCase(updateScreeningInfo.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            // })
            .addCase(corporateResendToScreening.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            // .addCase(sendToCheckerMlro.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            // })
            // .addCase(manageScreeningAction.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            // })
            // .addCase(getAdverseMedia.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.adverseMedias = payload.data;
            //     state.error = null;
            // })
            // .addCase(getCorporateFieldHistory.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            //     state.fieldHistory = payload.data;
            // })
            // .addCase(getCorporateScreeningComments.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            //     state.screeningComments = payload.data;
            // })
            // .addCase(uploadMediaImage.fulfilled, (state, {payload})=>{
            //     state.isLoading = false;
            //     state.error = null;
            // })
            // .addCase(saveAmlInfoComment.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            // })
            // .addCase(saveAdverseMediaComment.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            // })
            // .addCase(fetchAmlComments.fulfilled, (state, {payload})=>{
            //     state.isLoading = false;
            //     state.error = null;
            //     state.amlComments=payload.data
            // })
            // .addCase(getCorporateScreeningClientHistory.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            //     state.oldData = payload.data;
            // })
            // .addCase(fetchCorporateRequestedDocuments.fulfilled, (state, {payload})=>{
            //     state.isLoading = false;
            //     state.error = null;
            //     state.corporateRequestedDocument=payload.data
            // })
            // .addCase(fetchPendingCorporateScreeningCount.fulfilled, (state, { payload }) => {
            //     state.isLoading = false;
            //     state.error = null;
            //     state.pendingCorporateScreeningCount = payload.data
            // })
            .addMatcher(isAnyOf(fetchCorporateScreeningList.pending, corporateResendToScreening.pending), (state) => {
                state.isLoading = true;
            })
            .addMatcher(isAnyOf(fetchCorporateScreeningList.rejected, corporateResendToScreening.rejected), (state, { error }) => {
                state.isLoading = false;
                state.error = (error) ? error.message : "Request Failed Please Try Again ";
            })
    }
});

const { resetCorporateScreeningList, updateCorporateScreeningList } = fetchCorporateScreeningSlice.actions;
const corporateScreeningReducer = fetchCorporateScreeningSlice.reducer;

export { resetCorporateScreeningList, updateCorporateScreeningList, corporateScreeningReducer };
export default corporateScreeningReducer;